export { IAction, IActionGroups, SolaryumPageComponent } from "./solaryum-page.component";
